import type { ReactNode } from 'react';

import type { TContainerElement } from '@shared/dream-components';
import { ContainerElement } from '@shared/dream-components';

interface Props {
  node: TContainerElement;
  children: ReactNode | ReactNode[];
}

const Container = ({ node, children }: Props) => {
  return <ContainerElement element={node}>{children}</ContainerElement>;
};

export default Container;
